import { selectAuthenticatedUser, useSelector } from '@missionlabs/api'
import { FC } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useGetUserQuery } from 'shared/store'

export interface RequireEmergencyDetailsProps {
    isDisabled?: boolean
}

export const RequireEmergencyDetails: FC<RequireEmergencyDetailsProps> = ({
    isDisabled = false
}) => {
    const location = useLocation()
    const auth = useSelector(selectAuthenticatedUser)

    const { data: user, isLoading } = useGetUserQuery(auth?.userID ?? '', {
        skip: !auth?.userID || isDisabled
    })

    if (isDisabled || isLoading || !user) return <Outlet />

    const hasUpdatedAddressTime = 'addressUpdatedTime' in user && !!user.addressUpdatedTime

    if (!hasUpdatedAddressTime && location.pathname !== '/home/emergency-details')
        return (
            <Navigate
                to="/home/emergency-details"
                replace
                state={{ redirect: location.pathname }}
            />
        )

    if (location.pathname === '/home/emergency-details' && hasUpdatedAddressTime) {
        return <Navigate to="/home" replace state={{ redirect: location.pathname }} />
    }

    return <Outlet />
}
